import { Link } from "react-router-dom";
import { AGENCY } from "../../data/content";
import { useCookieConsent } from "../../context/CookieContext";

export const Footer = () => {
  const { openSettings } = useCookieConsent();
  return (
    <footer className="bg-[#0B0D11] text-[#9AA3AF] py-16 md:py-20 px-6 md:px-12 border-t border-[#2A303A]" data-testid="main-footer">
      <div className="max-w-7xl mx-auto grid md:grid-cols-3 gap-12">
        <div>
          <p className="font-display text-xl font-bold text-[#F2F4F7]">
            Nordhorizont<span className="text-[#2E5BFF]"> Digital</span>
          </p>
          <p className="mt-4 text-sm leading-relaxed">
            Moderne Websites für Mittelstandsbetriebe.<br />
            {AGENCY.region}<br />
            {AGENCY.domain}
          </p>
        </div>
        <div>
          <p className="text-xs uppercase tracking-widest text-[#5B6470] mb-4">Rechtliches</p>
          <ul className="space-y-3 text-sm">
            <li><Link to="/impressum" className="hover:text-[#2E5BFF] transition-colors" data-testid="footer-link-impressum">Impressum</Link></li>
            <li><Link to="/datenschutz" className="hover:text-[#2E5BFF] transition-colors" data-testid="footer-link-datenschutz">Datenschutz</Link></li>
            <li>
              <button onClick={openSettings} className="hover:text-[#2E5BFF] transition-colors" data-testid="footer-cookie-settings">
                Cookie-Einstellungen
              </button>
            </li>
          </ul>
        </div>
        <div>
          <p className="text-xs uppercase tracking-widest text-[#5B6470] mb-4">Kontakt</p>
          <a href={`mailto:${AGENCY.email}`} className="text-sm font-semibold text-[#F2F4F7] hover:text-[#2E5BFF] transition-colors break-all" data-testid="footer-email-link">
            {AGENCY.email}
          </a>
        </div>
      </div>
      <div className="max-w-7xl mx-auto mt-14 pt-8 border-t border-[#2A303A] text-xs text-[#5B6470]">
        © {new Date().getFullYear()} {AGENCY.name}, {AGENCY.region}
      </div>
    </footer>
  );
};
